// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-2TQAp","small":"small-a__T9","medium":"medium-3soQD","spinner":"spinner-4vMyG"};